import React from 'react'
import { Row, Col, Radio, DatePicker } from 'antd'
import Dropdown from 'react-dropdown'
import { initialNational, initialLevel } from 'utils/constants'
import { get } from 'lodash'
import { parseSafe } from 'utils/helper'
import Input from 'component/Input'

import { renderColValue } from 'utils/helper'

const Unicorn = ({ formik, editable, userProfile, userData }) => {
  const name = get(userProfile, 'name', '') || get(userData, 'partner.name', '')
  const birthDay = get(userProfile, 'birthday', '')
  const contact = get(userProfile, 'contact', '')
  const educationLevel = get(userProfile, 'education_level', '')
  const race = get(userProfile, 'race', '')
  const experience = get(userProfile, 'experience', '')
  const gender = get(userProfile, 'gender', '')
  const nationality = get(userProfile, 'nationality', '')
  const occupation = get(userProfile, 'occupation', '')
  const passport = get(userProfile, 'passport', '')
  const phone = get(userProfile, 'phone', '')
  const postalAddress = get(userProfile, 'postal_address', '')
  const postalCode = get(userProfile, 'postal_code', '')
  const additionalInfo = parseSafe(get(userProfile, 'additional_info'))
  const other_level = additionalInfo?.other_level
  const unitNumber = get(userProfile, 'unit_number', '')

  const handleChangePhoneNum = ({ currentTarget }) => {
    var regExp = /^[0-9]{1,13}$/

    if (regExp.test(currentTarget.value) || currentTarget.value === '') {
      formik.setFieldValue('phone', currentTarget.value)
    }
  }

  const handleChangeEmergencyContact = ({ currentTarget }) => {
    var regExp = /^[0-9]{1,13}$/

    if (regExp.test(currentTarget.value) || currentTarget.value === '') {
      formik.setFieldValue('emergency_contact', currentTarget.value)
    }
  }

  const handleChangeExp = ({ currentTarget }) => {
    var regExp = /^[0-9]{1,3}$/

    if (regExp.test(currentTarget.value) || currentTarget.value === '') {
      formik.setFieldValue('year_exp', currentTarget.value)
    }
  }

  return (
    <div>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          NAME (ACCORDING TO ID/PASSPORT):
        </Col>
        <Col xs={renderColValue(24, 10)} md={6} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="name"
                placeHolder="Enter your full name"
                formik={formik}
                value={formik.values.name}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            name
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Gender:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <Radio.Group
              onChange={(e) => formik.setFieldValue('gender', e.target.value)}
              value={formik.values.gender}
              name="add-course__radio-type"
            >
              <Radio value="male">Male</Radio>
              <Radio value="female">Female</Radio>
            </Radio.Group>
          ) : (
            <span style={{ textTransform: 'capitalize' }}>{gender}</span>
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Date of Birth:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <DatePicker
                onChange={(date, dateString) => {
                  formik.setFieldValue('date_of_birth', date)
                }}
                allowClear
                value={formik.values.date_of_birth}
                placeholder="Date of Birth"
                className="sc-modal__datepicker"
                style={{ width: '100%' }}
              />
            </div>
          ) : (
            birthDay
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Nationality:
        </Col>
        <Col md={6} className="profile__text" xs={renderColValue(24, 10)}>
          {editable ? (
            <div className="profile__field__wrapper">
              <Dropdown
                options={initialNational}
                onChange={(value) =>
                  formik.setFieldValue('nationality', value.label)
                }
                value={formik.values.nationality}
                placeholder="Select Nationality"
                className="dropdownScheduleModal"
              />

              {formik.values.nationality === 'Other' && (
                <div style={{ marginTop: 20 }}>
                  <Input
                    name="other_nationality"
                    placeHolder="Type another nationality here"
                    formik={formik}
                    value={formik.values.other_nationality}
                    onChange={formik.handleChange}
                    style={{ padding: 8 }}
                  />
                </div>
              )}
            </div>
          ) : (
            nationality
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          ID/Passport No. (eg. NRIC):
        </Col>
        <Col md={6} xs={10} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="passport"
                placeHolder="Enter ID/Passport"
                formik={formik}
                value={formik.values.passport}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            passport
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Phone No.:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="phone"
                placeHolder="Enter Phone No."
                formik={formik}
                value={formik.values.phone}
                onChange={handleChangePhoneNum}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            phone
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Emergency Contact:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="emergency_contact"
                placeHolder="Enter Emergency Phone No."
                formik={formik}
                value={formik.values.emergency_contact}
                onChange={handleChangeEmergencyContact}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            contact
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Postal Address:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="address"
                placeHolder="Enter Postal Address"
                formik={formik}
                value={formik.values.address}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            postalAddress
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Postal Code:
        </Col>
        <Col md={6} className="profile__text" xs={renderColValue(24, 10)}>
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="postTalCode"
                placeHolder="Enter Postal Code"
                formik={formik}
                value={formik.values.postTalCode}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            postalCode
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Unit No.:
        </Col>
        <Col md={6} className="profile__text" xs={renderColValue(24, 10)}>
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="unit_number"
                placeHolder="Enter Unit Number"
                formik={formik}
                value={formik.values.unit_number}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            unitNumber
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Highest Education Level:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div style={{ marginRight: 35 }}>
              <Dropdown
                options={initialLevel}
                onChange={(value) =>
                  formik.setFieldValue('education_level', value.label)
                }
                value={formik.values.education_level}
                placeholder="Select Education Level"
                className="dropdownScheduleModal"
              />

              {(formik.values.education_level === 'Other' ||
                formik.values.education_level === 'GCE N-Level') && (
                <div style={{ marginTop: 20 }}>
                  <Input
                    name="other_level"
                    placeHolder={
                      formik.values.education_level === 'GCE N-Level'
                        ? 'Relevant Work Experience'
                        : 'Type another education level here'
                    }
                    formik={formik}
                    value={formik.values.other_level}
                    onChange={formik.handleChange}
                    style={{ padding: 8 }}
                  />
                </div>
              )}
            </div>
          ) : educationLevel === 'GCE N-Level' ? (
            <div>
              <div>{educationLevel}</div>
              <div>{other_level}</div>
            </div>
          ) : (
            educationLevel
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Years Of Experience:
        </Col>
        <Col md={6} xs={10} className="profile__text">
          {editable ? (
            <div style={{ marginRight: 35 }}>
              <Input
                name="year_exp"
                placeHolder="Years Of Experience"
                formik={formik}
                value={formik.values.year_exp}
                onChange={handleChangeExp}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            experience
          )}
        </Col>
      </Row>
      <Row className="profile__row">
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Race:
        </Col>
        <Col md={6} xs={renderColValue(24, 10)} className="profile__text">
          {editable ? (
            <div style={{ marginRight: 35 }}>
              <Input
                name="race"
                placeHolder="Enter Race"
                formik={formik}
                value={formik.values.race}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            race
          )}
        </Col>
        <Col
          className="profile__name-2 profile__col"
          md={6}
          xs={renderColValue(24, 12)}
        >
          Occupation:
        </Col>
        <Col md={6} className="profile__text" xs={renderColValue(24, 10)}>
          {editable ? (
            <div className="profile__field__wrapper">
              <Input
                name="occupation"
                placeHolder="Enter Occupation"
                formik={formik}
                value={formik.values.occupation}
                onChange={formik.handleChange}
                style={{ padding: 8 }}
              />
            </div>
          ) : (
            occupation
          )}
        </Col>
      </Row>
    </div>
  )
}

export default Unicorn
